import React, { useEffect, useReducer, useState } from "react";
import ReactDOM from "react-dom"

const PointBuyHelper = (props) => {

	const [strength, setStrength] = useState("13");
	const [dexterity, setDexterity] = useState("13");
	const [constitution, setConstitution] = useState("13");
	const [intelligence, setIntelligence] = useState("12");
	const [wisdom, setWisdom] = useState("12");
	const [charisma, setCharisma] = useState("12");

	const maxPoints = 27;

	const [currentPoints, setCurrentPoints] = useState(27);
	const [remainingPoints, setRemainingPoints] = useState(maxPoints);

	const prices = {
		8: 0,
		9: 1,
		10: 2,
		11: 3,
		12: 4,
		13: 5,
		14: 7,
		15: 9
	};

	const mods = {
		1 : -5,
		2 : -4,
		3: -4,
		4:-3,
		5:-3,
		6:-2,
		7:-2,
		8: -1,
		9:-1,
		10:0,
		11:0,
		12:1,
		13:1,
		14:2,
		15:2,
		16:3,
		17:3,
		18:4,
		19:4,
		20:5,
		21:5,
		22:6,
		23:6,
		24:7,
		25:7,
		26:8,
		27:8,
		28:9,
		29:9,
		30:30

	};

	const resetPoints = () => {
		setStrength(8);
		setDexterity(8);
		setConstitution(8);
		setIntelligence(8);
		setWisdom(8);
		setCharisma(8);
	}

	useEffect(() => {
		let currentPointValue = prices[strength] + prices[dexterity] + prices[constitution] + prices[intelligence] + prices[wisdom] + prices[charisma];
		setCurrentPoints(currentPointValue);
		setRemainingPoints(maxPoints - currentPointValue);
	}, [strength, dexterity, constitution, intelligence, wisdom, charisma]);


	return <>
		<div className="row">
			<div className="col-12 col-md-6">

				<ul className="list-group list-group-flush">
					<li className="list-group-item ps-0 ms-0 mt-2 pt-0 mb-1 pb-0 ms-0 ps-0 me-0 pe-0">

						<h5 className="d-flex justify-content-between">
							<span>Maximale Punkte:</span>
							<span className="o-80">{maxPoints}</span>
						</h5>

						<h5 className="d-flex justify-content-between">
							<span>Verbrauchte Punkte: </span>
							<span className="o-80">{currentPoints}</span>

						</h5>

						<h5 className="d-flex justify-content-between">
							<span>Verbleibende Punkte: </span>
							<span className="o-80">{remainingPoints}</span>
						</h5>

						<br />
						
						<button className="btn btn-primary mb-4" onClick={() => { resetPoints() }}>Zurücksetzen</button>

						<br />

						{remainingPoints < 0 &&
							<div className="alert alert-danger  mb-4">
								Sie haben zu viele Punkte ausgegeben. Reduzieren Sie Ihr Kontingent um {(remainingPoints * -1)} Punkt(e).
							</div>
						}
					</li>
				</ul>

			</div>
			<div className="col-12 col-md-6">

				<ul className="list-group list-group-flush">
					<li className="list-group-item ps-0 ms-0 mt-2 pt-0 mb-1 pb-0">
						<h5 className="d-flex justify-content-between">
							<span>Stärke:</span> <span className="o-80">{strength} ({mods[strength]})</span></h5>
							<input className="form-range" type="range" value={strength} min="8" max="15" step="1" onChange={(e) => { setStrength(e.target.value) }} />
					</li>

					<li className="list-group-item ps-0 ms-0 mt-2 pt-0 mb-1 pb-0">
						<h5 className="d-flex justify-content-between">
							<span>Geschicklichkeit:</span> <span className="o-80">{dexterity} ({mods[dexterity]})</span></h5>
						<input className="form-range" type="range" value={dexterity} min="8" max="15" step="1" onChange={(e) => { setDexterity(e.target.value) }} />
					</li>

					<li className="list-group-item ps-0 ms-0 mt-2 pt-0 mb-1 pb-0">
						<h5 className="d-flex justify-content-between">
							<span>Konstitution:</span> <span className="o-80">{constitution} ({mods[constitution]})</span></h5>
						<input className="form-range" type="range" value={constitution} min="8" max="15" step="1" onChange={(e) => { setConstitution(e.target.value) }} />
					</li>

					<li className="list-group-item ps-0 ms-0 mt-2 pt-0 mb-1 pb-0">
						<h5 className="d-flex justify-content-between">
							<span>Intelligenz:</span> <span className="o-80">{intelligence} ({mods[intelligence]})</span></h5>
						<input className="form-range" type="range" value={intelligence} min="8" max="15" step="1" onChange={(e) => { setIntelligence(e.target.value) }} />
					</li>

					<li className="list-group-item ps-0 ms-0 mt-2 pt-0 mb-1 pb-0">
						<h5 className="d-flex justify-content-between">
							<span>Weisheit:</span> <span className="o-80">{wisdom} ({mods[wisdom]})</span></h5>						<input className="form-range" type="range" value={wisdom} min="8" max="15" step="1" onChange={(e) => { setWisdom(e.target.value) }} />
					</li>

					<li className="list-group-item ps-0 ms-0 mt-2 pt-0 mb-1 pb-0">
						<h5 className="d-flex justify-content-between">
							<span>Charisma:</span> <span className="o-80">{charisma} ({mods[charisma]})</span></h5>
						<input className="form-range" type="range" value={charisma} min="8" max="15" step="1" onChange={(e) => { setCharisma(e.target.value) }} />
					</li>
				</ul>
			</div>
		</div>





	</>
}

export default PointBuyHelper